<template>
  <div class="l-page l-page--abtest">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">
        <h2 class="c-title u-w100p">
          <div class="c-title__text c-title__text--blue u-fs34">A/Bテスト配信の作成</div>
          <div class="c-text u-fs14">条件が異なる２パターンのプッシュ通知を配信し、効果を比較してみましょう。</div>
        </h2>
      </div>
      <div class="l-main-content">
        <div class="p-abtest">
          <div class="p-abtest-list">
            <div class="p-abtest-list__item">
              <div class="c-image"><img src="/assets/img/sketch-abtest-01.svg" /></div>
              <div class="p-abtest-content">
                <h3 class="c-title">コンテンツ比較の配信テスト</h3>
                <div class="c-text">
                  タイトルや本文、画像を２パターン作成し配信することでユーザーの興味のあるコンテンツを比較調査します。<br />タイトル文頭のワードを変えたり、ロゴ画像を写真画像に変えたりと、コンテンツを比較した配信効果を検証いただけます。
                </div>
              </div>
              <a class="c-btn c-btn--blue u-w230 u-h66 u-fs16 u-text-center" :href="linkData.messageAddUrl">
                <p class="c-btn__text">コンテンツ比較の<br />A/Bテストを始める</p>
              </a>

            </div>
            <div class="p-abtest-list__item">
              <div class="c-image"><img src="/assets/img/sketch-abtest-02.svg" /></div>
              <div class="p-abtest-content">
                <h3 class="c-title">曜日・時間帯での配信テスト</h3>
                <div class="c-text">
                  配信する日時を変えて配信することで最適な配信タイミングを比較調査します。午前と午後で同じコンテンツ内容で配信を行い時間帯による配信効果が検証いただけます。</div>
              </div>
              <a class="c-btn c-btn--blue u-w230 u-h66 u-fs16 u-text-center" :href="linkData.timezoneAddUrl">
                <p class="c-btn__text">曜日・時間帯の<br />A/Bテストを始める</p>
              </a>

            </div>
            <div class="p-abtest-list__item">
              <div class="c-image"><img src="/assets/img/sketch-abtest-03.svg" /></div>
              <div class="p-abtest-content">
                <h3 class="c-title">属性別（デモグラフィック別）での配信テスト</h3>
                <div class="c-text">
                  属性を変えたメッセージを配信し属性ごとの比較調査を行います。<br />性別や年代別で同じコンテンツを配信することで、各属性による配信効果を検証いただけます。</div>
              </div>
              <a class="c-btn c-btn--blue u-w230 u-h66 u-fs16 u-text-center" :href="linkData.demograAddUrl">
                <p class="c-btn__text">属性別配信の<br />A/Bテストを始める</p>
              </a>

            </div>
          </div>
        </div>
        <div class="p-abtest-result">
          <h2 class="c-title u-w600">
            <div class="c-title__text u-fs18">設定されているテスト一覧</div>
          </h2>
          <div class="p-abtest-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty}">
            <loader v-if="isLoading" />
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--abtest">
              <thead>
                <tr>
                  <th class="c-table__cell--center u-w146 is-sortable">
                    <span class="c-table__text">配信日時</span>
                    <sort-switch name="deliverDate" :order="sortTargets.deliverDate" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">テスト項目</span>
                    <sort-switch name="abtestType" :order="sortTargets.abtestType" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w350 is-sortable">
                    <span class="c-table__text">テスト名</span>
                    <sort-switch name="abtestName" :order="sortTargets.abtestName" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">ステータス</span>
                    <sort-switch name="abtestStatus" :order="sortTargets.abtestStatus" @on-click="onSortButtonClick($event)" />
                  </th>
                  <th class="c-table__cell--center"></th>
                </tr>
              </thead>
              <tbody v-if="abtests">
                <abtest-list-item
                  v-for="(abtest,index) in abtests.data"
                  :key="index"
                  :abtest="abtest"
                  :abtest-info="abtestInfo"
                  @delete-click="onDeleteClick"
                  @stop-click="onStopClick"
                  @copy-click="onCopyClick"
                  @edit-click="onEditClick"
                />
              </tbody>
            </table>
            <pagination v-if="paginationInfo" :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="以下のテストを削除してもよろしいですか?"
      :body="'テスト : ' + currentAbtestName"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalDelete"
    />

    <!-- モーダル: 停止確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-puse"
      title="以下のテストを停止してもよろしいですか?"
      :body="'テスト : ' + currentAbtestName"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active=isStopMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalStop"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    linkData: Object,
    csrfToken: String,
    abtestInfo: Object,
  },
  data () {
    return {
      sortTargets: {
        deliverDate: -1,
        abtestType: 0,
        abtestName: 0,
        abtestStatus: 0,
      },
      abtests: null,
      paginationInfo: null,
      isLoading: false,
      isDeleteMessage: false,
      isStopMessage: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      currentAbtestName: null,
    }
  },
  mounted: function() {
    import('../../funcs/pages/abtest').then(module => {
      module.Abtest();
    });
    this.loadData();
  },
  methods: {
    loadData: function() {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      this.isLoading = true;

      // 配信状況データの取得処理実行
      axios.get('/api/abtest/list',params)
        .then(res => {
          this.abtests = res.data.abtests;
          this.paginationInfo = res.data.abtests;
          setTimeout(() => {
            this.isLoading = false;
            if (res.data.abtests.data.length < 1) this.isEmpty = true;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '設定されているABテスト一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },
    onSortButtonClick: function(target) {
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
    onDeleteClick: function(abtest) {
      this.isDeleteMessage = true;
      this.currentAbtestId = abtest.abtest_id;
      this.currentAbtestName = abtest.abtest_name;
    },
    onStopClick: function (abtest) {
      this.isStopMessage = true;
      this.currentAbtestId = abtest.abtest_id;
      this.currentAbtestName = abtest.abtest_name;
    },
    onCopyClick: function(abtestId) {
      location.href = this.abtestInfo.addUrl + '?type=copy&abtest_id=' + abtestId;
    },
    onEditClick: function(abtestId) {
      location.href = this.abtestInfo.addUrl + '?type=edit&abtest_id=' + abtestId;
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.isStopMessage = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理 ※ 削除
    onEnterConrolModalDelete() {
      this.handleAction('delete');
    },

    // クリック: 操作モーダルのENTER処理 ※ 停止
    onEnterConrolModalStop() {
      this.handleAction('stop');
    },

    handleAction(actionType) {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // パラメタ作成
      const params = {
        abtest_id: this.currentAbtestId,
      };

      const apiUrl = actionType === 'delete' ? '/api/abtest/delete' : '/api/abtest/stop';

      axios.post(apiUrl, params)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDeleteMessage = false;
          this.isStopMessage = false;
          this.errorMessage = '';
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage(`テストの${actionType === 'delete' ? '削除' : '停止'}に失敗しました`);
          this.handleHttpError(error);
        });
    },
  }
}
</script>
